import { ButtonProps, DefaultButtonIcon, Text, Weight } from 'components'
import React, { useEffect, useState } from 'react'
import {
  ArbitrumIcon,
  AvalancheIcon,
  ButtonWrapper,
  EthereumIcon,
  OptimismIcon,
  PendingDot,
  PolygonIcon,
  StyledWalletButton,
  UnsupportedIcon,
  BscIcon,
  BaseIcon,
} from './styled'

import { useConnectModal } from '@rainbow-me/rainbowkit'
import ConnectIcon from 'assets/button-icons/connect-icon.svg?react'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'
import { useAtomValue } from 'jotai'
import { isPending, storedTransactionsAtom } from 'services'
import { useMultiTransactionState } from 'services/pending-transactions-context'
import { useStore } from 'services/store'
import { useAccount } from 'wagmi'
import { userAccountAtom } from 'context/account'
import { isAddressEqual, zeroAddress } from 'viem'

export const showCurrentNetwork = (
  network: number,
  isTour?: boolean,
): {
  name: string
  icon: JSX.Element
} => {
  if (isTour) {
    return {
      name: 'Ethereum',
      icon: <EthereumIcon />,
    }
  }

  switch (network) {
    case 43114:
      return {
        name: 'Avalanche',
        icon: <AvalancheIcon />,
      }
    case 42161:
      return {
        name: 'Arbitrum',
        icon: <ArbitrumIcon />,
      }

    case 1:
      return {
        name: 'Ethereum',
        icon: <EthereumIcon />,
      }

    case 10:
      return {
        name: 'OP Mainnet',
        icon: <OptimismIcon />,
      }

    case 8453:
      return {
        name: 'Base',
        icon: <BaseIcon />,
      }

    case 56:
      return {
        name: 'BNB Smart Chain',
        icon: <BscIcon />,
      }

    //TESTNETS
    case 43113:
      return {
        name: 'Avalanche Fuji',
        icon: <AvalancheIcon />,
      }

    case 80001:
      return {
        name: 'Polygon Mumbai',
        icon: <PolygonIcon />,
      }
    case 11155420:
      return {
        name: 'Sepolia Optimism',
        icon: <OptimismIcon />,
      }
    case 11155111:
      return {
        name: 'Sepolia',
        icon: <EthereumIcon />,
      }

    //
    default:
      return {
        name: 'Unsupported',
        icon: <UnsupportedIcon />,
      }
  }
}

export const WalletButton: React.FC<ButtonProps> = ({ className, buttonType }) => {
  const { isConnected, isConnecting, chain } = useAccount()
  const [text, setText] = useState<string>('Connect wallet')
  const { openConnectModal } = useConnectModal()
  const { connectionModal, setConnectionModal } = useStore()
  const { pending: omniPending } = useMultiTransactionState()
  const transactions = useAtomValue(storedTransactionsAtom)
  const userAddress = useAtomValue(userAccountAtom)
  const pendingTransactions = transactions
    .filter(({ account }) => isAddressEqual(account, userAddress ?? zeroAddress))
    .filter(isPending)
  const { run } = useTourGuide()

  useEffect(() => {
    if (run) {
      setText('Connected')
      return
    }
    if (isConnected) {
      setText('Connected')
    } else if (isConnecting) {
      setText('Connecting...')
    } else {
      setText('Connect wallet')
    }
  }, [isConnected, isConnecting, run])

  const buttonHandler = () => {
    if (!isConnected && !isConnecting && openConnectModal) {
      openConnectModal()
    } else if (!connectionModal) {
      setConnectionModal(true)
    }
  }

  const showDot = () => {
    if (pendingTransactions.length !== 0 || omniPending) return <PendingDot />
    return null
  }
  return (
    <ButtonWrapper>
      <StyledWalletButton
        connected={isConnected}
        className={className}
        buttonType={buttonType}
        text={''}
        onClick={buttonHandler}
        icon={
          buttonType === 'primary' ? (
            <DefaultButtonIcon icon={ConnectIcon} />
          ) : (
            (chain && showCurrentNetwork(chain.id).icon) ?? undefined
          )
        }
      >
        <Text type="four" weight={Weight.Regular}>
          {text}
        </Text>
      </StyledWalletButton>
      {showDot()}
    </ButtonWrapper>
  )
}
